const initialState = () => ({
  imports: [],
});

const state = initialState();

export default state;
